import type { Device, Tier } from "@arfood/shared";

export interface AppContext {
  venue: string;
  loc?: string | undefined;
  table?: string | undefined;
  lang?: string | undefined;
  tier: Tier | null;
  device: Device;
}

// Defense-in-Depth: nur id-artige Tokens aus der URL zulassen, damit ein
// manipulierter QR/Link keinen Freitext/PII in den Event-Store schleust.
// Primäre Kontrolle bleibt die Allow-List serverseitig in /e (Phase 1).
const ID_RE = /^[\w.:-]{1,64}$/;
function sanitizeId(v: string | null): string | undefined {
  return v && ID_RE.test(v) ? v : undefined;
}

// QR-Deep-Links: ?v=venue&loc=location&t=table&lang=..&tier=Tx
export function readContext(defaultVenue: string): AppContext {
  const p = new URLSearchParams(location.search);
  const tierRaw = p.get("tier");
  const tier: Tier | null = tierRaw === "T0" || tierRaw === "T1" || tierRaw === "T2" ? tierRaw : null;
  return {
    venue: sanitizeId(p.get("v")) ?? defaultVenue,
    loc: sanitizeId(p.get("loc")),
    table: sanitizeId(p.get("t")),
    lang: p.get("lang") ?? undefined,
    tier,
    device: detectDevice(),
  };
}

export function detectDevice(): Device {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) return "ios";
  if (/Android/.test(ua)) return "android";
  return "other";
}
